module.exports = __webpack_public_path__ + "img/xiumianIcon.026f2188.png";